import { SET_NTV } from './mutations';

const setNTV = ({ commit }, payload) => commit(SET_NTV, payload);

export default {
    setNTV,
};
